import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function BillingCancel() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-stone-50 p-6" data-testid="billing-cancel">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
                <XCircle size={40} className="mx-auto text-stone-500 mb-4" />
                <h1 className="font-display text-3xl text-stone-900">No worries — nothing was charged.</h1>
                <p className="text-sm text-stone-500 mt-3">
                    Your trial is still active. Come back anytime you&apos;re ready to upgrade.
                </p>
                <Link
                    to="/pricing"
                    className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-stone-900 text-white text-sm font-semibold hover:bg-stone-800"
                    data-testid="billing-back-to-pricing"
                >
                    <ArrowLeft size={14} /> Back to plans
                </Link>
            </div>
        </div>
    );
}
